// removed by extract-text-webpack-plugin
module.exports = {"Content":"-name__-loca-__3pLYC"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Layout/Layout.css
// module id = 153
// module chunks = 0